module.exports = __webpack_public_path__ + "static/media/spender.bcc31ee0.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/spender.png
// module id = 132
// module chunks = 0